import React from 'react'

function Load() {
  return (
        <div className='load-container'>
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Load